export const USERS_LOADING = "USERS_LOADING";
export const USERS_ERROR = "USERS_ERROR";
export const USERS_GET_LIST = "USERS_GET_LIST";
export const USERS_GET_FILTERS = "USERS_GET_FILTERS";
export const USERS_GET_SINGLE = "USERS_GET_SINGLE";
export const USERS_UPDATE_SINGLE = "USERS_UPDATE_SINGLE";
export const USERS_UPDATE_PACKAGE = "USERS_UPDATE_PACKAGE";
export const USERS_UPDATE_TARIFF = "USERS_UPDATE_TARIFF";



// WEBPACK FOOTER //
// ./src/actions/users/constants.js